export default __webpack_public_path__ + "static/media/194.11de4f45.png";